import { uploadAsset } from './upload-assets'

type UploadArtistParams = {
  file: File
  title: string
}

export async function uploadArtistAsset({ file, title }: UploadArtistParams) {
  const [privateFiles, publicFiles] = await Promise.all([
    uploadAsset({
      file,
      folder: 'artists',
      title,
      visibility: 'private',
    }),
    uploadAsset({
      file,
      folder: 'artists',
      title,
      visibility: 'public',
    }),
  ])

  return {
    privateFile: privateFiles[0],
    publicFile: publicFiles[0],
  }
}

export async function uploadArtistPhoto({ file, title }: UploadArtistParams) {
  return uploadArtistAsset({ file, title })
}
